import React from 'react';
import clsx from 'clsx';

import './index.scss';

const HatenaIcon = ({ text, place })=> {
  const DispText = () => {
    return Array.isArray(text) 
      ? text.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{text}</>;
  };
  return(
    <span className="HatenaIcon">
      <span className="hatena">
        ?
      </span>
      <span className={clsx('text', 
        { pc: place === 'pc' },
        { sp: place === 'sp' },
      )}
      >
        <DispText />
      </span>
    </span>
  );
};

export default HatenaIcon;